export default function updatePaywall() {
    // add terms & conditions text to checkout page
    let checkoutPrivacyPolicy = document.querySelector('#quantity-section .columns.checkout-options');
    
    let privacyPolicy = document.createElement('div');
    privacyPolicy.id = 'privacy-policy';
    privacyPolicy.classList.add('privacy-policy');
    privacyPolicy.innerHTML = `
        <p>
            ClickUp uses Stripe to process your payment. The information you share with us to purchase your course is governed by Stripe's <a href="https://stripe.com/in/privacy">Privacy Policy</a>.
        </p>
    `;

    checkoutPrivacyPolicy.append(privacyPolicy);
};
